import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
	ViewEncapsulation,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

import { LinkComponent } from '@valk-nx/components/ui-link/src/lib/link';
import { BaseDirective } from '@valk-nx/core/lib/directives/base/base.directive';
import { LinkModule } from '@valk-nx/core/lib/directives/link/link.module';
import { WhatsappModule } from '@valk-nx/core/lib/pipes/whatsapp/whatsapp.module';

import {
	FooterInformation,
	FooterMenu,
	FooterMenuLink,
	FooterUSP,
} from './footer.interface';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	selector: 'vp-footer',
	templateUrl: './footer.html',
	imports: [
		CommonModule,
		LinkModule,
		LinkComponent,
		AngularSvgIconModule,
		WhatsappModule,
		RouterModule,
		TranslatePipe,
	],
})
export class FooterComponent extends BaseDirective {
	@Input() bottomItems: FooterMenuLink[] | undefined = undefined;
	@Input() information: FooterInformation | undefined = undefined;
	@Input() isMinimal = false;
	@Input() title = '';
	@Input() menu: FooterMenu = {
		items: [
			{
				title: '',
				items: [
					{
						title: '',
						url: '',
					},
				],
			},
		],
	};
	@Input() usps: FooterUSP[] = [
		{
			icon: 'assets/icons/logo-valk-white.svg',
			text: '',
			url: '',
		},
		{
			icon: 'assets/icons/logo-valk-white.svg',
			text: 'Valk verrast',
			url: '',
		},
	];

	@Input() socials: {
		facebook?: string;
		instagram?: string;
		tiktok?: string;
		youtube?: string;
		linkedin?: string;
		pinterest?: string;
	} | null = {
		facebook: 'https://www.facebook.com/VanderValkVerrast',
		instagram: 'https://www.instagram.com/valkverrast',
		tiktok: undefined,
		youtube: undefined,
		linkedin: undefined,
		pinterest: undefined,
	};

	@Output() toTop: EventEmitter<void> = new EventEmitter<void>();

	constructor(public override translate: TranslateService) {
		super(translate);
	}

	scrollToTop(): void {
		this.toTop.emit();
		window.scrollTo({
			behavior: 'smooth',
			left: 0,
			top: 0,
		});
	}
}
